import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import routes from '../../routes';
// import { AlertProps } from '../Alert';
// import YourSkillsAndJobMatches from '../YourSkillsAndJobMatches';

export default function Success() {
  const location: any = useLocation();
  if (!location.state?.fromSignup) return <Redirect to={routes.home} />;
  // const message: AlertProps = {
  //   title: 'Welcome to Matilda process!',
  //   message: `Here you will find your skills profile and
  //             a summary of how many potential matches we have for you at this moment.
  //             You can always get back to this information from the top-right menu
  // ("Your skills and jobs").
  //             Now go visit your application process with the link on the side.`,
  // };
  return null; // <YourSkillsAndJobMatches message={message} />;
}
